import { Analytics } from "@vercel/analytics/react";
import { useAtomValue } from "jotai";
import { lazy, Suspense, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { EntryScreen } from "./components/EntryScreen";
import { PageLoadingFallback } from "./components/LoadingFallback";
import { URLSearchParamsHandler } from "./hooks/URLSearchParamsHandler";
import { userIdentifyAtom } from "./store/user";

// Lazy load all page components
const Home = lazy(() => import("./pages/Home"));
const Scan = lazy(() =>
  import("./pages/Scan").then((module) => ({ default: module.Scan }))
);
const ScanQrCode = lazy(() =>
  import("./pages/ScanQrCode").then((module) => ({
    default: module.ScanQrCode,
  }))
);

const Profile = lazy(() =>
  import("./pages/user/Profile").then((module) => ({ default: module.Profile }))
);
const Setting = lazy(() =>
  import("./pages/user/Setting").then((module) => ({ default: module.Setting }))
);
const User = lazy(() => import("./pages/user/User"));
const UserUpdated = lazy(() =>
  import("./pages/user/UserUpdated").then((module) => ({
    default: module.UserUpdated,
  }))
);
const VerifyEmail = lazy(() =>
  import("./pages/user/verifyEmail").then((module) => ({
    default: module.VerifyEmail,
  }))
);
const VerifyFailed = lazy(() =>
  import("./pages/verifyResult/VerifyFailed").then((module) => ({
    default: module.VerifyFailed,
  }))
);
const VerifyGoBack = lazy(() =>
  import("./pages/verifyResult/VerifyGoBack").then((module) => ({
    default: module.VerifyGoBack,
  }))
);
const VerifyRegistrationSuccess = lazy(() =>
  import("./pages/verifyResult/VerifyRegistrationSuccess").then((module) => ({
    default: module.VerifyRegistrationSuccess,
  }))
);
const VerifySuccess = lazy(() =>
  import("./pages/verifyResult/VerifySuccess").then((module) => ({
    default: module.VerifySuccess,
  }))
);


const Email = lazy(() =>
  import("./pages/Email").then((module) => ({ default: module.Email }))
);

const ResultPage = lazy(() =>
  import("./pages/verifyResult/ResultPage").then((module) => ({
    default: module.ResultPage,
  }))
);

function App() {
  const userIdentify = useAtomValue(userIdentifyAtom);

  const isMobile = /Mobile|Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(
    navigator.userAgent
  );

  useEffect(() => {
    if (!userIdentify && window.location.pathname.includes("/user")) {
      // window.location.href = "/";
    }
  }, [userIdentify]);

  if (!isMobile && window.innerWidth > 1024) {
    return <EntryScreen />;
  }

  return (
    <>
      <Analytics />
      <BrowserRouter>
        <URLSearchParamsHandler />
        <Suspense fallback={<PageLoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/user" element={<User />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/email" element={<Email />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="/user/profile" element={<Profile />} />
            <Route path="/user/setting" element={<Setting />} />
            <Route path="/user/verifyEmail" element={<VerifyEmail />} />
            <Route path="/user/updated" element={<UserUpdated />} />
            <Route path="/verify-failed" element={<VerifyFailed />} />
            <Route path="/verify-success" element={<VerifySuccess />} />
            <Route path="/verify-go-back" element={<VerifyGoBack />} />
            <Route
              path="/verify-registration-success"
              element={<VerifyRegistrationSuccess />}
            />
            <Route path="/scan/qr" element={<ScanQrCode />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        toastOptions={{
          className: "mt-[20px]",
        }}
      />
    </>
  );
}

export default App;
